 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		22: 0
 	};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		22: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"commons","1":"styles","2":"80886e9e5cc3c93c09daf12669334e7fdd72d086","3":"eb5004b32bcc37c23a2d9da63d2c07c368c36b7f","4":"89f2b66160969fcee250a836f7e55b9f012b096e","5":"7e1b41a39d53f78bc1f810d2d782d9a0e771f6bb","6":"c1cf265a01f345d14ea1f0fa4ad0295a61b17b69","7":"d67daa68dbb7fa5191482c38df4c1ce001f648ce","8":"5ed64baea96c5e28e37e0a3396666fd35d096cd9","9":"b9390e6aecf2b5cb0f159fd5482310f090c8dfbf","10":"ea88be26","11":"7c5ead21e5908f6f25786a511bc70f58e243c1f8","12":"dc594759cb49af661456344cd3ccafd180f5a3e7","13":"6e0d12b2ab3c3a2df6231519f20de4866e9961bf","14":"965e77cbf5d7fd4e7e7e3c8afb64a368e6ced68f","15":"1fe38f8b2c6ac76250641bb343cb2acacb47860c","16":"7723483330c604f709063740994781512be65870","17":"6a4601cf9fc0354f92bde813334f371c96fdc7f1","18":"7880189ec4542ee1989400b4fa6eb530dd978131","19":"a1fda6617e25b9837fea1bf683b2d8ad818416f8","20":"f1fbbf37dbc369d2d0a08906033a0959ac810c1a","21":"fa9fe86e28d2e8d761e1503e2765752a859afffd","24":"component---src-pages-404-js","25":"component---src-pages-about-index-js","26":"component---src-pages-blog-js","27":"component---src-pages-contact-js","28":"component---src-pages-index-js","29":"component---src-pages-notification-js","30":"component---src-pages-portfolio-index-js","31":"component---src-pages-portfolio-map-js","32":"component---src-pages-privacy-js","33":"component---src-pages-terms-js","34":"component---src-pages-under-construction-js","35":"component---src-pages-unsubscribe-js","36":"component---src-templates-blog-article-js","37":"component---src-templates-project-briefing-js","38":"component---src-templates-project-gallery-js","39":"component---src-templates-project-location-js","40":"component---src-templates-project-progress-js","41":"component---src-templates-project-snapshot-js","42":"component---src-templates-project-timeline-js","43":"component---src-templates-project-timeline-post-js","44":"component---src-templates-project-vision-js","45":"e7ff715b","48":"reactPlayerDailyMotion","49":"reactPlayerFacebook","50":"reactPlayerFilePlayer","51":"reactPlayerKaltura","52":"reactPlayerMixcloud","53":"reactPlayerMux","54":"reactPlayerPreview","55":"reactPlayerSoundCloud","56":"reactPlayerStreamable","57":"reactPlayerTwitch","58":"reactPlayerVidyard","59":"reactPlayerVimeo","60":"reactPlayerWistia","61":"reactPlayerYouTube"}[chunkId]||chunkId) + "-" + {"0":"883c536043b49d61d5cb","1":"e9d24b1846c7d6eb9685","2":"1f55644424c00c6db55b","3":"ea08557e5d12ad635ff6","4":"0d9644ada149ae6d071a","5":"0a14feed95f8e72de50d","6":"f5a25ef82c622e293dcf","7":"8834e2d535134eeffec3","8":"28baf9b0aa8f6a5216e5","9":"5a37ecd35e441e61cdec","10":"6f47a9e7e96854bab82d","11":"61c6bfb4fd59a3340a43","12":"1a4dd584d7b3e26ceebf","13":"2b619487f0cf180547a2","14":"f59978bfa0c6e4ed95ff","15":"0330275b9c9f3d8e4289","16":"5bd54147ce02d75f75da","17":"644e540f2cbe4e753a76","18":"6f2e4bcae86a1403ec24","19":"2900e54df96c7b63e5f0","20":"bb9ff539dd9696071921","21":"45485b4a44a45629f20e","24":"79305d7fbcfabd319a95","25":"1ef64b62150f8b6372f7","26":"df1e706823b4e790c78f","27":"a1ca832eef0cd46882fd","28":"e9ee77a84991c30fec9d","29":"16f6b8e83a1d0f4aa705","30":"e23d316b539072212a74","31":"20ed77d4917b7df295dc","32":"2de285c25b0beeb58cd0","33":"5701898f1a2f3f66ca5f","34":"588d11e5c0c67e2719d6","35":"aa4efcdbb0b328eef048","36":"4ee19360a2dd59da7eff","37":"338dc5a234341dbd6676","38":"8195a87acc82fa38d1e0","39":"4738cd4286796dbfefce","40":"ecba9357d6934ead2f48","41":"a5c21102651261f14e58","42":"1e0fde6ecfa233c73f62","43":"aa80c33ca8170143a873","44":"02961d5dc95c181cc3d3","45":"e1fe443378cadbac377a","48":"18a6cfdcf6d7161b2d70","49":"736f2450d856ea4c1b96","50":"eebbf92adb0134827b12","51":"90211f589b9739ba6743","52":"bd9fbf28f184ea9b9cd6","53":"39b1dfaf97d2a3d46a8d","54":"d11bff83ca2cf0e6c640","55":"fbd8c211b51455b47951","56":"c3890359903c1f80183a","57":"0ccd15c95cbf4f895d38","58":"726bbe6031229bd999f2","59":"b09d8ad8a16be731fb66","60":"cdcee32b1bcde2365a91","61":"9047689a5191a0c8c001","62":"8dcc6c0def3bf65617e0"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"1":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "" + ({"0":"commons","1":"styles","2":"80886e9e5cc3c93c09daf12669334e7fdd72d086","3":"eb5004b32bcc37c23a2d9da63d2c07c368c36b7f","4":"89f2b66160969fcee250a836f7e55b9f012b096e","5":"7e1b41a39d53f78bc1f810d2d782d9a0e771f6bb","6":"c1cf265a01f345d14ea1f0fa4ad0295a61b17b69","7":"d67daa68dbb7fa5191482c38df4c1ce001f648ce","8":"5ed64baea96c5e28e37e0a3396666fd35d096cd9","9":"b9390e6aecf2b5cb0f159fd5482310f090c8dfbf","10":"ea88be26","11":"7c5ead21e5908f6f25786a511bc70f58e243c1f8","12":"dc594759cb49af661456344cd3ccafd180f5a3e7","13":"6e0d12b2ab3c3a2df6231519f20de4866e9961bf","14":"965e77cbf5d7fd4e7e7e3c8afb64a368e6ced68f","15":"1fe38f8b2c6ac76250641bb343cb2acacb47860c","16":"7723483330c604f709063740994781512be65870","17":"6a4601cf9fc0354f92bde813334f371c96fdc7f1","18":"7880189ec4542ee1989400b4fa6eb530dd978131","19":"a1fda6617e25b9837fea1bf683b2d8ad818416f8","20":"f1fbbf37dbc369d2d0a08906033a0959ac810c1a","21":"fa9fe86e28d2e8d761e1503e2765752a859afffd","24":"component---src-pages-404-js","25":"component---src-pages-about-index-js","26":"component---src-pages-blog-js","27":"component---src-pages-contact-js","28":"component---src-pages-index-js","29":"component---src-pages-notification-js","30":"component---src-pages-portfolio-index-js","31":"component---src-pages-portfolio-map-js","32":"component---src-pages-privacy-js","33":"component---src-pages-terms-js","34":"component---src-pages-under-construction-js","35":"component---src-pages-unsubscribe-js","36":"component---src-templates-blog-article-js","37":"component---src-templates-project-briefing-js","38":"component---src-templates-project-gallery-js","39":"component---src-templates-project-location-js","40":"component---src-templates-project-progress-js","41":"component---src-templates-project-snapshot-js","42":"component---src-templates-project-timeline-js","43":"component---src-templates-project-timeline-post-js","44":"component---src-templates-project-vision-js","45":"e7ff715b","48":"reactPlayerDailyMotion","49":"reactPlayerFacebook","50":"reactPlayerFilePlayer","51":"reactPlayerKaltura","52":"reactPlayerMixcloud","53":"reactPlayerMux","54":"reactPlayerPreview","55":"reactPlayerSoundCloud","56":"reactPlayerStreamable","57":"reactPlayerTwitch","58":"reactPlayerVidyard","59":"reactPlayerVimeo","60":"reactPlayerWistia","61":"reactPlayerYouTube"}[chunkId]||chunkId) + "." + {"0":"31d6cfe0d16ae931b73c","1":"f8db44c44944f0992a24","2":"31d6cfe0d16ae931b73c","3":"31d6cfe0d16ae931b73c","4":"31d6cfe0d16ae931b73c","5":"31d6cfe0d16ae931b73c","6":"31d6cfe0d16ae931b73c","7":"31d6cfe0d16ae931b73c","8":"31d6cfe0d16ae931b73c","9":"31d6cfe0d16ae931b73c","10":"31d6cfe0d16ae931b73c","11":"31d6cfe0d16ae931b73c","12":"31d6cfe0d16ae931b73c","13":"31d6cfe0d16ae931b73c","14":"31d6cfe0d16ae931b73c","15":"31d6cfe0d16ae931b73c","16":"31d6cfe0d16ae931b73c","17":"31d6cfe0d16ae931b73c","18":"31d6cfe0d16ae931b73c","19":"31d6cfe0d16ae931b73c","20":"31d6cfe0d16ae931b73c","21":"31d6cfe0d16ae931b73c","24":"31d6cfe0d16ae931b73c","25":"31d6cfe0d16ae931b73c","26":"31d6cfe0d16ae931b73c","27":"31d6cfe0d16ae931b73c","28":"31d6cfe0d16ae931b73c","29":"31d6cfe0d16ae931b73c","30":"31d6cfe0d16ae931b73c","31":"31d6cfe0d16ae931b73c","32":"31d6cfe0d16ae931b73c","33":"31d6cfe0d16ae931b73c","34":"31d6cfe0d16ae931b73c","35":"31d6cfe0d16ae931b73c","36":"31d6cfe0d16ae931b73c","37":"31d6cfe0d16ae931b73c","38":"31d6cfe0d16ae931b73c","39":"31d6cfe0d16ae931b73c","40":"31d6cfe0d16ae931b73c","41":"31d6cfe0d16ae931b73c","42":"31d6cfe0d16ae931b73c","43":"31d6cfe0d16ae931b73c","44":"31d6cfe0d16ae931b73c","45":"31d6cfe0d16ae931b73c","48":"31d6cfe0d16ae931b73c","49":"31d6cfe0d16ae931b73c","50":"31d6cfe0d16ae931b73c","51":"31d6cfe0d16ae931b73c","52":"31d6cfe0d16ae931b73c","53":"31d6cfe0d16ae931b73c","54":"31d6cfe0d16ae931b73c","55":"31d6cfe0d16ae931b73c","56":"31d6cfe0d16ae931b73c","57":"31d6cfe0d16ae931b73c","58":"31d6cfe0d16ae931b73c","59":"31d6cfe0d16ae931b73c","60":"31d6cfe0d16ae931b73c","61":"31d6cfe0d16ae931b73c","62":"31d6cfe0d16ae931b73c"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
